import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 pt-32 md:pt-40 pb-20 md:pb-28">
        <div className="max-w-2xl mx-auto text-center">
          <div className="relative">
            <span className="font-heading text-[7rem] md:text-[10rem] leading-none text-background-200 select-none">
              404
            </span>
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-2xl">
                <i className="ri-emotion-sad-line" />
              </span>
            </span>
          </div>
          <h1 className="mt-6 font-heading text-2xl md:text-3xl text-foreground-950">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm text-foreground-500">
            找不到与 <span className="font-mono text-foreground-700 break-all">{location.pathname}</span> 对应的看点内容，可能是链接过期或输入有误。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-home-4-line" />
              回到首页
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors"
            >
              查看常见问题
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}